/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDto } from './CreateDiscreteNumericListDto';
import {
    CreateDiscreteNumericListDtoFromJSON,
    CreateDiscreteNumericListDtoFromJSONTyped,
    CreateDiscreteNumericListDtoToJSON,
} from './CreateDiscreteNumericListDto';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';

/**
 * 
 * @export
 * @interface CreatePhotonBeamQualityDoseRateValueListDto
 */
export interface CreatePhotonBeamQualityDoseRateValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    radiationType?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    energy?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    highDoseTechniqueType?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateDiscreteNumericListDto}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    selectedDoseRates?: CreateDiscreteNumericListDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    primaryFluenceShaping: CreateEnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDoseRateValueListDto
     */
    $type?: CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreatePhotonBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreatePhotonBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum = typeof CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum[keyof typeof CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum];



/**
 * Check if a given object implements the CreatePhotonBeamQualityDoseRateValueListDto interface.
 */
export function instanceOfCreatePhotonBeamQualityDoseRateValueListDto(value?: unknown): value is CreatePhotonBeamQualityDoseRateValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum)[0];
}

export function CreatePhotonBeamQualityDoseRateValueListDtoFromJSON(json: any): CreatePhotonBeamQualityDoseRateValueListDto {
    return CreatePhotonBeamQualityDoseRateValueListDtoFromJSONTyped(json, false);
}

export function CreatePhotonBeamQualityDoseRateValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePhotonBeamQualityDoseRateValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'beamQualityId': json['beamQualityId'] == null ? undefined : json['beamQualityId'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'name': json['name'] == null ? undefined : json['name'],
        'radiationType': json['radiationType'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['radiationType']),
        'energy': json['energy'] == null ? undefined : CreateNumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': json['highDoseTechniqueType'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'selectedDoseRates': json['selectedDoseRates'] == null ? undefined : CreateDiscreteNumericListDtoFromJSON(json['selectedDoseRates']),
        'primaryFluenceShaping': CreateEnumerationValueDtoFromJSON(json['primaryFluenceShaping']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreatePhotonBeamQualityDoseRateValueListDtoToJSON(value?: CreatePhotonBeamQualityDoseRateValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'beamQualityId': value['beamQualityId'],
        'isEnabled': value['isEnabled'],
        'name': value['name'],
        'radiationType': CreateEnumerationValueDtoToJSON(value['radiationType']),
        'energy': CreateNumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': CreateEnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        'selectedDoseRates': CreateDiscreteNumericListDtoToJSON(value['selectedDoseRates']),
        'primaryFluenceShaping': CreateEnumerationValueDtoToJSON(value['primaryFluenceShaping']),
        '$type': value['$type'],
    });
}

